{
  "reprint": {
    "printFailed": "تعذرت الطباعة"
  },
  "resend": {
    "title": "إعادة الإرسال",
    "statement": "إعادة إرسال رسالة {{template}} إلى {{phone}}"
  },
  "edit": {
    "title": "تعديل الأمانة",
    "description": "هذا التعديل يتطلب سبب التعديل، ويسجل في سجل التعديلات.",
    "attachmentLabel": "مرفق داعم",
    "attachmentOptional": "اختياري",
    "attachmentHint": "PDF أو JPEG أو PNG، بحد أقصى 5 ميغابايت",
    "attachmentTooLarge": "حجم المرفق يتجاوز 5 ميغابايت",
    "attachmentTypeInvalid": "نوع المرفق غير مسموح",
    "substantiveFields": "المبلغ والعملة وهوية طرف والمستلم المقصود تعديلات جوهرية",
    "substantiveNotice": "تعديل جوهري: يظهر التوقيع السابق بوصف وُقّع على نسخة سابقة",
    "sections": {
      "amountCurrency": "المبلغ والعملة",
      "depositor": "المودع",
      "intendedRecipient": "المستلم المقصود",
      "actualRecipient": "المستلم الفعلي"
    },
    "removeIntended": "إزالة المستلم المقصود",
    "noChangesYet": "لم يتغير أي حقل بعد",
    "resignOffer": {
      "title": "إعادة الإرسال إلى التابلت",
      "description": "تعديل جوهري. يمكن إرسال الأمانة إلى التابلت ليوقع المودع من جديد.",
      "skip": "تخطي"
    },
    "chooseAttachment": "اختيار ملف",
    "noAttachment": "لم يتم اختيار ملف"
  },
  "referralReview": {
    "title": "مراجعة الإحالة",
    "employeeNote": "ملاحظة الموظف",
    "referredBy": "الموظف الذي أحال",
    "recordedRecipient": "بيانات المستلم المسجلة",
    "signature": "التوقيع المسجل",
    "decisionRequired": "القرار مطلوب",
    "noteRequired": "الملاحظة مطلوبة"
  },
  "cancel": {
    "title": "إلغاء الأمانة",
    "statement": "إلغاء الأمانة رقم {{number}}، المبلغ {{amount}}، المودع {{name}}",
    "reasonLabel": "سبب الإلغاء",
    "confirmNoCashHeld": "لا يوجد نقد محتفظ به لهذه الأمانة",
    "returnHint": "إذا كان النقد قد استلم فعلا، فالإجراء الصحيح هو استرداد الأمانة"
  }
}
